/**
 * Query key factory for Subscriptions.
 *
 * `member()` prefixes every read that belongs to the signed-in member (their
 * entitlement, their payments), apart from the catalogue, which is the same
 * for everyone and public.
 */
export const subscriptionKeys = {
  all: ['subscriptions'] as const,

  plans: () => [...subscriptionKeys.all, 'plans'] as const,
  plan: (planId: number) => [...subscriptionKeys.all, 'plan', planId] as const,

  member: () => [...subscriptionKeys.all, 'member'] as const,
  me: () => [...subscriptionKeys.member(), 'me'] as const,
  payments: () => [...subscriptionKeys.member(), 'payments'] as const,
}
